module.exports = __webpack_public_path__ + "img/slide5-mb.e7ff97f0.png";